import { store } from '@/app/store';
import { usePendingChanges } from '@/app/websocket/hooks';

import FlexRow from './FlexRow';
import Button from './Button';

const ChangeNotificationBanner = () => {
  const pendingChanges = usePendingChanges();

  if (pendingChanges.length === 0) return null;

  const message =
    pendingChanges.length === 1
      ? `${pendingChanges[0].user} made changes to ${pendingChanges[0].type}. Refresh to see latest?`
      : `${pendingChanges.length} changes detected from other users. Refresh to see latest?`;

  return (
    <FlexRow flex={0} className="bg-[#E3F2FD] rounded-[6px] px-[16px] py-[6px] gap-[12px] items-center shadow-sm">
      <span className="material-icons !text-[#1976D2] !text-[18px]">
        info_outline
      </span>
      <span className="r12 text-[#1A1A1A] whitespace-nowrap">
        {message}
      </span>
      <FlexRow flex={0} className="gap-[6px]">
        <Button
          caption="Refresh"
          icon="refresh"
          onClick={() => store.acceptRefresh()}
        />
        <Button
          caption="Dismiss"
          layout="white"
          onClick={() => store.dismissRefresh()}
        />
      </FlexRow>
    </FlexRow>
  );
};

export default ChangeNotificationBanner;
